import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export const SHomepageCallToAction = styled.div<{ mirrored?: boolean }>`
  margin: 0 var(--p-content);
  position: relative;

  ${({ mirrored }) =>
    mirrored &&
    css`
      @media ${BREAKPOINTS.MD.min} {
        display: flex;
        justify-content: flex-end;

        ${SHomepageCallToActionGallery} {
          left: 0;
        }
      }
    `}
`

export const SHomepageCallToActionContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: calc(50% - 4rem);

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`

export const SHomepageCallToActionContentBox = styled.div`
  position: relative;
  padding: 43px 92px 43px 0;
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media ${BREAKPOINTS.LG.max} {
    padding: 20px 10px 20px 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 0 43px 0;
  }
`

export const SHomepageCallToActionText = styled(Text)`
  margin-bottom: 27px;
`

export const SHomepageCallToActionGallery = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 49%;
  height: 100%;
  overflow: hidden;

  & > img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 15%;
  }

  @media ${BREAKPOINTS.MD.max} {
    position: relative;
    width: 100%;
    height: 20rem;
    max-height: 38vh;
    margin: 1rem 0;

    & > img {
      object-position: center 14%;
    }
  }
`
